import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API_APPLY_COUPON, API_CONFIRM_ORDER, API_CREATE_RAZORPAY_ORDER, API_GET_CHECKOUT, API_VERIFY_RAZORPAY_ORDER, WEBSITE_NAME } from "../modals/Constants";
import general from "../css/General.module.css";
import screen from "../css/Screen.module.css";
import { getStorage } from "../modals/Storage";
import AlertDialog from "../dialogs/AlertDialog/dialog";
import LoadingDialog from "../dialogs/LoadingDialog/dialog";
import HeaderView from "../other-components/HeaderView/view";
import Button from "../UI/Button/ui";
import RupeeIcon from "../media/icons/rupee_icon.png";
import UpiIcon from "../media/icons/upi_icon.png";

function Checkout() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");

  const [alertDialog, updatetAlertDialog] = useState({
    title: 'Required!',
    description: '',
    visible: false
  });

  const [values, setConstants] = useState({
    totalRecords: 0,
    totalAmount: 0,
    totalDiscount: 0,
    totalDeliveryFee: 0,
    subTotal: 0,
    couponDiscount: 0,
    discountSubTotal: 0,
    appliedCoupon: "",
    cartThreshold: "",

    currentPage: 1,
    totalPages: 0,
    pagination: false,

    razorpayAPI: "",
    codPayment: true,
    onlinePayment: true,
    codPaymentCharges: 0,

    address: [],
  });

  function onPaymentMethodSelected(method) {
    if (paymentMethod !== method && method === 'cod' && values.codPaymentCharges > 0) {
      let newSubtotal = values.subTotal + Number(values.codPaymentCharges);
      newSubtotal = Number(newSubtotal.toFixed(2));

      setConstants((previousState) => {
        return {
          ...previousState,
          subTotal: newSubtotal,
        };
      });
    } else if (paymentMethod !== method && paymentMethod !== "" && method !== 'cod' && values.codPaymentCharges > 0) {
      let newSubtotal = values.subTotal - Number(values.codPaymentCharges);
      newSubtotal = Number(newSubtotal.toFixed(2));

      setConstants((previousState) => {
        return {
          ...previousState,
          subTotal: newSubtotal,
        };
      });
    }

    setPaymentMethod(method);
  }

  function setAlertDialog({ title = '', description = '', visible = true }) {
    if (title === '') {
      title = alertDialog.title;
    }

    updatetAlertDialog((previousState) => {
      return {
        ...previousState,
        title: title,
        description: description,
        visible: visible
      };
    });
  }

  function loadRecords() {
    async function requestAPI(url, formData) {
      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'authorization': `Bearer ${getStorage("accountSecret")}`,
          },
          body: JSON.stringify(formData),
        });

        const data = await res.json();
        setLoading(false);

        if (data.status_code === "success") {
          if (!data.cod_allowed && data.online_payment_allowed) {
            setPaymentMethod("online");
          } else if (data.cod_allowed && !data.online_payment_allowed) {
            setPaymentMethod("cod");
          }

          setConstants((previousState) => {
            return {
              ...previousState,
              currentPage: data.current_page,
              totalPages: data.total_pages,
              totalRecords: data.total_records,
              totalAmount: data.total_amount,
              totalDiscount: data.total_discount,
              totalDeliveryFee: data.total_delivery_fee,
              subTotal: data.total_subtotal,
              address: data.address,
              razorpayAPI: data.razorpay_api_key,
              codPayment: data.cod_allowed,
              onlinePayment: data.online_payment_allowed,
              codPaymentCharges: data.cod_payment_charges,
              cartThreshold: data.cart_threshold,
            };
          });
        }
      } catch (error) {
        setLoading(false);
      }
    };

    setLoading(true);
    const formData = { ACCOUNT_ID: getStorage("accountID") };
    requestAPI(API_GET_CHECKOUT, formData);
  }

  const confirmOrder = ({ payment_id = "", order_id = "" } = {}) => {
    async function requestAPI(url, formData) {
      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'authorization': `Bearer ${getStorage("accountSecret")}`,
          },
          body: JSON.stringify(formData),
        });

        const data = await res.json();
        setLoading(false);

        if (data.status_code === "success") {
          navigate('/order-confirmed', { replace: true });
        } else {
          setAlertDialog({ description: `There is a technical error. Please contact us.` });
        }
      } catch (error) {
        setLoading(false);
      }
    };

    setLoading(true);
    const formData = {
      ACCOUNT_ID: getStorage("accountID"),
      PAYMENT_MODE: paymentMethod,
      COUPON: values.appliedCoupon,
      PAYMENT_ID: payment_id,
      ORDER_ID: order_id,
    };
    requestAPI(API_CONFIRM_ORDER, formData);
  }

  const applyCoupon = () => {
    async function requestAPI(url, formData) {
      try {
        const res = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'authorization': `Bearer ${getStorage("accountSecret")}`,
          },
          body: JSON.stringify(formData),
        });

        const data = await res.json();
        setLoading(false);

        if (data.status_code === "success") {
          setConstants((previousState) => {
            return {
              ...previousState,
              appliedCoupon: couponCode,
              couponDiscount: data.total_discount,
              subTotal: data.total_subtotal
            };
          });

          // setCouponCode("")
        } else if (data.status_code === "invalid_coupon") {
          setAlertDialog({ description: "Invalid Coupon code." });
        }
      } catch (error) {
        setLoading(false);
      }
    };

    if (paymentMethod !== "") {
      if (values.appliedCoupon !== "") {
        setAlertDialog({ description: "Coupon code already applied." });
      } else if (couponCode.length > 4) {
        setLoading(true);
        const formData = {
          ACCOUNT_ID: getStorage("accountID"),
          SUBTOTAL: values.subTotal,
          COUPON: couponCode,
        };

        requestAPI(API_APPLY_COUPON, formData);
      } else {
        setAlertDialog({ description: "Invalid Coupon code." });
      }
    } else {
      setAlertDialog({ description: "Please select a payment method to continue." });
    }
  }

  const continueToPurchase = () => {
    if (values.address.length === 0) {
      setAlertDialog({ description: "Please select an address to continue." });
    } else if (paymentMethod === "") {
      setAlertDialog({ description: "Please select a payment method to continue." });
    } else {
      if (values.subTotal >= values.cartThreshold) {
        if (paymentMethod === "online") {
          payViaRazorpay();
        } else {
          confirmOrder();
        }
      } else {
        setAlertDialog({ description: `A minimum order of ₹${values.cartThreshold} is required to proceed to checkout.` });
      }
    }
  }

  const payViaRazorpay = async () => {
    try {
      setLoading(true);
      const formData = {
        ACCOUNT_ID: getStorage("accountID"),
        AMOUNT: values.subTotal
      };

      const res = await fetch(API_CREATE_RAZORPAY_ORDER, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'authorization': `Bearer ${getStorage("accountSecret")}`,
        },
        body: JSON.stringify(formData),
      });

      const data = await res.json();
      setLoading(false);

      if (data.status_code === 'success') {
        // 2. Razorpay options
        const options = {
          key: values.razorpayAPI,
          amount: data.order.amount,
          currency: data.order.currency,
          order_id: data.order.id,
          name: { WEBSITE_NAME },
          description: `Paying for ${values.totalRecords} items (₹${values.subTotal})`,
          handler: async function (response) {
            let payment_id = response.razorpay_payment_id;
            let order_id = response.razorpay_order_id;

            // Verify payment on backend
            const verifyRes = await fetch(API_VERIFY_RAZORPAY_ORDER, {
              method: "POST",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
              },
              body: new URLSearchParams({
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
              }),
            });

            const verifyData = await verifyRes.json();
            if (verifyData.status === 'success') {
              confirmOrder({ payment_id, order_id })
            }
          },
          prefill: {
            name: "John Doe",
            email: "john@example.com",
            contact: "9999999999",
          },
          theme: {
            color: "#3399cc",
          },
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    loadRecords();
  }, []);

  return (
    <div className={general.appView}>
      <LoadingDialog isOpen={loading} />

      <AlertDialog
        isOpen={alertDialog.visible}
        title={alertDialog.title}
        description={alertDialog.description}
        onClose={() => setAlertDialog({ visible: false })}
        actions={[
          { label: "Close", variant: "neutral", onClick: () => setAlertDialog({ visible: false }) }
        ]}
      />

      <div className={general.appChildView}>
        <HeaderView screen={"checkout"} />

        <div className={general.appLocationViews}>
          <p>Checkout</p>
        </div>

        <div className={general.appContentsView}>

          <div className={`${screen.checkoutView} ${general.mgB100px}`}>
            <div className={screen.contentsView}>
              <section>
                <p className={screen.sectionHint}>Address</p>

                <div className={screen.sectionView}>
                  {values.address.length > 0 && (
                    <>
                      <div>
                        <p className={screen.title}>{values.address[0]['item_fullname']}</p>
                        <p>Mobile: {values.address[0]['item_mobile']}</p>
                        <p>{values.address[0]['item_address']}</p>
                      </div>

                      <Link className={[general.primaryBtn, general.rounded1x].join(" ")} to={"/myaddress"}>
                        Select
                      </Link>
                    </>
                  )}

                  {values.address.length <= 0 ?
                    <>
                      <div>
                        <p className={screen.title}>Not selected</p>
                        <p>Please select an address</p>
                      </div>

                      <Link className={[general.primaryBtn, general.rounded1x].join(" ")} to={"/myaddress"}>
                        Select
                      </Link>
                    </>
                    : null}
                </div>
              </section>

              <section>
                <p className={screen.sectionHint}>Payment Methods</p>

                <div className={[screen.sectionView, general.mgT20px, general.cursorPointer].join(" ")} onClick={() => values.codPayment && (onPaymentMethodSelected("cod"))}>
                  <div className={screen.sectionChildView}>
                    <img src={RupeeIcon} alt="icon" />

                    <div>
                      <p className={screen.title}>Cash on delivery</p>
                      <p className={values.codPayment ? screen.description : screen.hint}>{values.codPayment ? 'Pay when you receive order.' : 'Not available'}</p>

                      {Number(values.codPaymentCharges) > 0 && (<p className={[general.fontSize14px, general.colorPrimary].join(" ")}>Required extra charges: ₹{values.codPaymentCharges}</p>)}
                    </div>
                  </div>

                  <div className={[general.radioBtn, paymentMethod === "cod" ? general.active : null].join(" ")}></div>
                </div>

                <div className={[screen.sectionView, general.mgT25px, general.cursorPointer].join(" ")} onClick={() => values.onlinePayment && (onPaymentMethodSelected("online"))}>
                  <div className={screen.sectionChildView}>
                    <img src={UpiIcon} alt="icon" />

                    <div>
                      <p className={screen.title}>Online Payment</p>
                      <p className={values.onlinePayment ? screen.description : screen.hint}>{values.onlinePayment ? 'Pay now for faster delivery.' : 'Not available'}</p>
                    </div>
                  </div>


                  <div className={[general.radioBtn, paymentMethod === "online" ? general.active : null].join(" ")}></div>
                </div>
              </section>
            </div>

            <div className={screen.overview}>
              <section>
                <p className={screen.title}>Cart totals</p>

                <br></br>
                <div>
                  <p>Coupon code</p>

                  <div>
                    <div className={[general.inpBoxOutline, general.mgT10px].join(" ")}>
                      <input
                        type="text"
                        placeholder="Enter a coupon code"
                        autoComplete="off"
                        value={couponCode}
                        disabled={values.appliedCoupon !== ""}
                        onChange={(e) => setCouponCode(e.target.value)}
                      ></input>

                      <button className={[general.primaryBtn, general.rounded1x].join(" ")} onClick={() => applyCoupon()}>
                        {values.appliedCoupon !== "" ? 'Applied' : 'Apply'}
                      </button>
                    </div>
                  </div>

                </div>


                <br></br>
                <div className={screen.listView}>
                  <p>Total Items (products)</p>
                  <p>{values.totalRecords}</p>
                </div>

                <div className={screen.listView}>
                  <p>Total MRP (Inc. of taxes)</p>
                  <p>₹{values.totalAmount}</p>
                </div>

                <div className={screen.listView}>
                  <p>Delivery Fee</p>
                  <p>{values.totalDeliveryFee > 0
                    ? "₹" + values.totalDeliveryFee
                    : "Free"}</p>
                </div>

                <div className={screen.listView}>
                  <p>Bag Discount</p>
                  <p>-₹{values.totalDiscount}</p>
                </div>

                {
                  paymentMethod === 'cod' && Number(values.codPaymentCharges) > 0 && (
                    <>
                      <div className={screen.listView}>
                        <p>Extra charges</p>
                        <p className={general.colorPrimary}>₹{values.codPaymentCharges}</p>
                      </div>
                    </>
                  )
                }

                <br></br>
                {values.couponDiscount > 0 ?
                  <div className={screen.listView}>
                    <p>Coupon applied</p>
                    <p className={general.colorPrimary}>-₹{values.couponDiscount}</p>
                  </div>
                  : null}

                <div className={screen.listView}>
                  <p>Sub Total</p>
                  <p className={screen.subTitle}>₹{values.subTotal}</p>
                </div>
              </section>

              <br></br>
              <Button
                text="Confirm order"
                rounded={true}
                fullWidth={true}
                action={{ onClick: () => continueToPurchase() }} />
            </div>

          </div>
        </div>
      </div>

    </div>
  );
}

export default Checkout;